import {
  AttributionBadge,
  EvidenceSection,
} from "@/admin/monitoring/evidence-parts"
import type { loadFileEvidence } from "@/admin/monitoring/file-evidence-data"
import { humanizeKey } from "@/admin/monitoring/run-presentation"
import { StoredDetails, StoredValue } from "@/admin/monitoring/stored-value"

export const FileEvidenceView = ({
  evidence,
  isAssessment,
}: {
  evidence: Awaited<ReturnType<typeof loadFileEvidence>>
  isAssessment: boolean
}) => (
  <div className="space-y-8 text-sm">
    <EvidenceSection title="Source Records">
      <p className="text-muted-foreground text-xs">
        {evidence.records.length === 0
          ? "No Source Records back this evidence."
          : `${evidence.records.length} of ${evidence.recordCount} shown.`}
      </p>
      {evidence.records.map((record) => (
        <article
          className="space-y-2 border-l-2 pl-3 text-xs"
          key={record.sourceRecordId}
        >
          <div className="flex flex-wrap items-center gap-2">
            <AttributionBadge attribution={record.attribution} />
            <span>{humanizeKey(record.recordKind)}</span>
          </div>
          <StoredValue value={record.matchedParty} />
          <StoredValue value={record.matchExplanation} />
          <StoredDetails
            summary="Source-recorded subject and roles"
            value={record.recordedSubject}
          />
          <StoredDetails
            summary="Stored Source Record"
            value={record.payload}
          />
        </article>
      ))}
    </EvidenceSection>
    {evidence.checks.length > 0 && (
      <EvidenceSection title="Source Checks">
        <div className="text-xs">
          <StoredValue value={evidence.checks} />
        </div>
      </EvidenceSection>
    )}
    {evidence.researchSufficiency && (
      <EvidenceSection title="Research Sufficiency">
        <div className="text-xs">
          <StoredValue value={evidence.researchSufficiency} />
        </div>
      </EvidenceSection>
    )}
    {isAssessment && (
      <EvidenceSection title="Assessment">
        <div className="text-xs">
          <StoredValue value={evidence.assessment} />
        </div>
      </EvidenceSection>
    )}
  </div>
)
